import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { CALL_INS_QUERY_KEY_ROOT } from "../utils/callIns";

/**
 * Mark every call-in read stale after a write that created, edited, or undid one.
 *
 * A removal writes through `publishChanges` / `POST /team/call-off`, neither of which touches the
 * `useGetLimitedCallOffs` cache — so a manager who removed someone kept seeing the pre-removal answer
 * until the query happened to refetch (window focus or a page reload). That is invisible on a grid the
 * manager isn't looking at, but very visible on the profile calendar and the mobile day list, where the
 * whole point is that the call-in shows up the moment it's recorded.
 *
 * Invalidates by **prefix**, so it covers every window and nurse-id variant at once — including the
 * disabled "combined" query the surfaces actually subscribe to, which the refetching page query
 * overwrites via `setQueryData`.
 *
 * Deliberately a standalone module: `useHandleNurseChange` needs it, and routing that through the
 * profile page's hook file would drag a page import into a core hook.
 */
export const useInvalidateCallIns = () => {
	const queryClient = useQueryClient();
	return useCallback(() => queryClient.invalidateQueries({ queryKey: [CALL_INS_QUERY_KEY_ROOT] }), [queryClient]);
};
